import { DonutChartFigurePropTypes } from "@/lib/types/visualizations/charts/DonutChart.types";

export default function DonutChartFigure({
  children,
  fullWidth,
}: DonutChartFigurePropTypes) {
  const figureStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    gap: "var(--spacing-lg)",
    padding: "var(--spacing-lg)",
    background: "var(--color-background-frame)",
    borderRadius: "var(--border-radius-md)",
    boxShadow: "0rem 0.3125rem 2.5rem 0rem rgba(29, 78, 216, 0.07)",
    height: "100%",
    width: fullWidth ? "100%" : "fit-content",
    minWidth: "fit-content",
    overflow: "hidden",
  };
  return <figure style={figureStyle}>{children}</figure>;
}
